<template>
	 
  <div>
    <div class="post-area" v-if="posts.length>0">
      <div class="post-type-select">
          <select>
              <option value="1">All Posts</option>
              <option value="2">Trending</option>
              <option value="3">Latest</option>
              <option value="4">Personal</option>
          </select>
      </div><!-- /. post-type-select -->

      <div class="post-wrap">
        <div class="post-single-wrap" v-for="(post, index) in posts" :key="index">
          <div class="card-header">
              <router-link to="/" class="autohor-details">
                <img v-if="post.author.proPic" :src="require(`@/assets/images/users/${post.author.proPic}`)" />
                <div class="author-name">
                  <div class="author-top">
                      <h2>
                          {{ post.author.name }}
                          <img src="../../assets/icon/varified-icon.svg" alt="varified">
                      </h2>
                      <a href="#">See More</a>
                  </div>
                  <p>@{{ post.author.userName }}</p>
                </div>
              </router-link>
              <base-dropdown class="post-setting dropdown-sm">
                  <div class="dropdown-sm-icon" slot="title">
                    <button class="search-btn dropdown-sm">
                      <img src="../../assets/icon/dot-toggle.svg" alt="varified">
                    </button>
                  </div>
                  <template>
                      <router-link to="/recently-used" class="dropdown-item ">
                          Recently used
                      </router-link>
                      <router-link to="/image-collections" class="dropdown-item">
                          Image Collections
                      </router-link>
                      <router-link to="/themes" class="dropdown-item ">
                         Themes
                      </router-link>
                  </template>
              </base-dropdown>
          </div><!-- /. card-header -->

          <div class="card-body story-desc-wrap">
            <img src="../../assets/images/posts-img/p1.jpeg" />
            <div class="story-description">
              <h2>Data title</h2>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
              quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
              proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            </div>
          </div><!-- /. card-body -->

          <div class="card-footer footer-social">
            <ul>    
              <reaction-emoji :postReaction="post.postReaction"></reaction-emoji>        
              <li>
                <img class="share-icon" src="../../assets/icon/repeat.svg" alt="share-icon" />
                <span>4</span>
              </li>
              <li>
                <img class="comment-icon" src="../../assets/icon/message-circle.svg" alt="comment-icon" />
                <span>5</span>
              </li> 
            </ul>

            <div class="post-comment">
              <textarea placeholder="Type something here..."></textarea>
              <button type="submit">Post</button>
            </div>
          </div><!-- /. card-footer -->

        </div>
      </div><!-- /. post-wrap -->
    </div>

    <div v-else>
      <div class="not-found-post">
          <img src="../../assets/icon/undraw_not_found.svg" alt="not-found" />
          <h4>This profile doesn't have any posts</h4>
      </div>
    </div><!-- /. empty-post -->
  </div>

</template>

<script>


export default {
    name: "posts",


    data(){
        return{
          posts:[
            {
              id:1,
              title: 'What is Lorem Ipsum?',
              img: 'p1.jpeg',
              desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
              author:{
                name: 'Shuvo sutradhar',
                userName:'shuvosd',
                proPic: 'avatar.png',
                verified: true
              },
              postReaction:[
                {
                  userId:1,
                  reaction:'love'
                },
                {
                  userId:2,
                  reaction:'wow'
                }
              ],
              postComments:[
                {
                  userId:1,
                  comment:"Comment goes to here.."
                },
                {
                  userId:2,
                  comment:"Comment goes to here.."
                },
                {
                  userId:3,
                  comment:"Comment goes to here.."
                }
              ],

            },
            {
              id:2,
              title: 'What is Lorem Ipsum?',
              img: 'p1.jpeg',
              desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum',
              author:{
                name: 'Shuvo sutradhar',
                userName:'shuvosd',
                proPic: 'avatar.png',
                verified: true
              },
              postReaction:[
                {
                  userId:1,
                  reaction:'love'
                },
                {
                  userId:2,
                  reaction:'wow'
                }
              ],
              postComments:[
                {
                  userId:1,
                  comment:"Comment goes to here.."
                },
                {
                  userId:2,
                  comment:"Comment goes to here.."
                },
                {
                  userId:3,
                  comment:"Comment goes to here.."
                }
              ],

            },
          ]
        }
    },

    methods: {
       
    }

}

</script>